// eslint-disable-next-line import/no-extraneous-dependencies
import type { DefaultOptionType } from 'rc-select/lib/Select';

import type {
  DimensionsOptionValue,
  DimensionsValue,
  MeasureUnitDimensionsValue,
} from 'src/components/base/fields/SpecificationField/SpecificationDimensionsField/SpecificationDimensionsField.types';
import type { IProductSpecificationOption } from 'src/types/reference/IProductSpecificationOption';
import {
  SPECIFICATION_MEASURE_UNIT_SHORT_MAPPER,
  type SpecificationMeasureUnit,
} from 'src/types/reference/SpecificationMeasureUnit';

export function getMeasureUnitDimensionsValueLabel(value: MeasureUnitDimensionsValue): string {
  if (value.height != null) {
    return `${value.length} x ${value.width} x ${value.height}${SPECIFICATION_MEASURE_UNIT_SHORT_MAPPER[value.measureUnit]}`;
  }

  return `${value.length} x ${value.width}${SPECIFICATION_MEASURE_UNIT_SHORT_MAPPER[value.measureUnit]}`;
}

export function toDimensionsOptionValue(value?: DimensionsValue): DimensionsOptionValue {
  return value != null
    ? Array.isArray(value)
      ? value.map(getMeasureUnitDimensionsValueLabel)
      : getMeasureUnitDimensionsValueLabel(value)
    : null;
}

export function toDimensionsValue(selectedOptions?: DefaultOptionType | DefaultOptionType[] | null): DimensionsValue {
  return selectedOptions != null
    ? Array.isArray(selectedOptions)
      ? selectedOptions.map((selectedOption) => ({
          measureUnit: selectedOption.measureUnit as SpecificationMeasureUnit,
          length: selectedOption.length as number,
          width: selectedOption.width as number,
          height: selectedOption.height as number | undefined,
        }))
      : {
          measureUnit: selectedOptions.measureUnit as SpecificationMeasureUnit,
          length: selectedOptions.length as number,
          width: selectedOptions.width as number,
          height: selectedOptions.height as number | undefined,
        }
    : null;
}

export function toDimensionsDefaultType(measureUnitOption: IProductSpecificationOption): DefaultOptionType {
  const label =
    measureUnitOption.length && measureUnitOption.width
      ? getMeasureUnitDimensionsValueLabel({
          measureUnit: measureUnitOption.measureUnit,
          length: measureUnitOption.length,
          width: measureUnitOption.width,
          height: measureUnitOption.height,
        })
      : measureUnitOption.label;

  return {
    label,
    value: label,

    // BaseType custom fields
    measureUnit: measureUnitOption.measureUnit,
    length: measureUnitOption.length,
    width: measureUnitOption.width,
    height: measureUnitOption.height,
  };
}

export function toCustomDimensionsDefaultType(measureUnitValue: MeasureUnitDimensionsValue): DefaultOptionType {
  const label = getMeasureUnitDimensionsValueLabel(measureUnitValue);

  return {
    label: label,
    value: label,

    // BaseType custom fields
    measureUnit: measureUnitValue.measureUnit,
    length: measureUnitValue.length,
    width: measureUnitValue.width,
    height: measureUnitValue.height,

    isCustom: true,
  };
}

export function areMeasureUnitDimensionsValueAndOptionEqual(
  a: MeasureUnitDimensionsValue,
  b: IProductSpecificationOption
): boolean {
  return a.measureUnit === b.measureUnit && a.length === b.length && a.width === b.width && a.height === b.height;
}
